import { FormType } from '../../../form-types';
import { SuboxoneQuestionFieldAnswers } from '../questions';

export const suboxoneFollowup: FormType<SuboxoneQuestionFieldAnswers> = {
  name: 'Suboxone Follow up',
  questions: [
    'suboxone_sexAssignedAtBirth',
    'suboxone_heightFeet',
    'suboxone_weightPounds',
    {
      key: 'suboxoneFollowup_healthChanges',
      next: {
        condition: { 'suboxoneFollowup_healthChanges.yes': true },
        key: 'suboxoneFollowup_healthChangesDetails',
        els: 'suboxoneFollowup_medicationDoing'
      }
    },
    'suboxoneFollowup_healthChangesDetails',
    {
      key: 'suboxoneFollowup_medicationDoing',
      next: {
        condition: { 'suboxoneFollowup_medicationDoing.not_well': true },
        key: 'suboxoneFollowup_medicationExperience',
        els: 'suboxoneFollowup_medicationAdherence'
      }
    },
    'suboxoneFollowup_medicationExperience',
    'suboxoneFollowup_medicationAdherence',
    'suboxoneFollowup_doseCravingControl',
    'suboxone_cravingSeverity',
    {
      key: 'suboxone_withdrawalSymptoms',
      next: {
        condition: { 'suboxone_withdrawalSymptoms.yes': true },
        key: 'suboxone_cowsHeartRate',
        els: 'suboxoneFollowup_opioidUseSinceLastVisit'
      }
    },
    'suboxone_cowsHeartRate',
    'suboxone_cowsSweating',
    'suboxone_cowsRestlessness',
    'suboxone_cowsPupilSize',
    'suboxone_cowsBoneMuscleAches',
    'suboxone_cowsRunnyNose',
    'suboxone_cowsGiSymptoms',
    'suboxone_cowsTremor',
    'suboxone_cowsYawning',
    'suboxone_cowsAnxiety',
    'suboxone_cowsGoosebumps',
    {
      key: 'suboxoneFollowup_opioidUseSinceLastVisit',
      next: {
        switch: [
          {
            condition: {
              'suboxoneFollowup_opioidUseSinceLastVisit.once_or_twice': true
            },
            key: 'suboxoneFollowup_opioidUseDetails'
          },
          {
            condition: {
              'suboxoneFollowup_opioidUseSinceLastVisit.weekly': true
            },
            key: 'suboxoneFollowup_opioidUseDetails'
          },
          {
            condition: {
              'suboxoneFollowup_opioidUseSinceLastVisit.several_times_week': true
            },
            key: 'suboxoneFollowup_opioidUseDetails'
          },
          {
            condition: {
              'suboxoneFollowup_opioidUseSinceLastVisit.daily_near_daily': true
            },
            key: 'suboxoneFollowup_opioidUseDetails'
          }
        ],
        els: 'suboxoneFollowup_sideEffects'
      }
    },
    'suboxoneFollowup_opioidUseDetails',
    {
      key: 'suboxoneFollowup_sideEffects',
      next: {
        condition: { 'suboxoneFollowup_sideEffects.other': true },
        key: 'suboxoneFollowup_sideEffectsOther',
        els: 'suboxoneFollowup_overdoseSinceLastVisit'
      }
    },
    'suboxoneFollowup_sideEffectsOther',
    'suboxoneFollowup_overdoseSinceLastVisit',
    'suboxone_naloxonePrescription',
    'suboxoneFollowup_treatmentPreference',
    'suboxone_additionalQuestions',
    {
      key: 'suboxone_consentTruthfulness',
      next: {
        condition: { 'suboxone_consentTruthfulness.non_consent': true },
        key: 'suboxone_didNotConsent',
        els: 'suboxone_consentOUD'
      }
    },
    {
      key: 'suboxone_consentOUD',
      next: {
        condition: { 'suboxone_consentOUD.non_consent': true },
        key: 'suboxone_didNotConsent',
        els: 'suboxone_complete'
      }
    },
    'suboxone_complete',
    'suboxone_ineligible',
    'suboxone_didNotConsent'
  ]
};
